import stile from './Skill.module.css';
import { useSprache } from '../sprache';
import { ErfahrungIcon, WissenIcon, ZertifikatIcon } from './LinienIcons';

function Skill({ title, logo, setTech, setShowPopup, experience, diplom, setSelectedCardRect }) {
  const { t } = useSprache();

  // Behandelt den Klick zur Anzeige des Detail-Popups
  const klickBehandeln = (ereignis) => {
    const kartenRechteck = ereignis.currentTarget.getBoundingClientRect();
    setSelectedCardRect(kartenRechteck);
    setTech(title);
    setShowPopup(true);
  };

  return (
    <div
      className={stile.skill}
      onClick={klickBehandeln}
      title={`${title} - ${t('skill.kartenHinweis')}`}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          klickBehandeln(e);
        }
      }}
    >
      {/* Erfahrungs-Abzeichen (links oben) */}
      <div
        className={`${stile.abzeichenEcke} ${stile.abzeichenLinks}`}
        title={t(experience ? 'skill.erfahrungVorhanden' : 'skill.wissenVorhanden')}
      >
        {experience
          ? <ErfahrungIcon groesse={16} titel={t('skill.erfahrung')} />
          : <WissenIcon groesse={16} titel={t('skill.wissen')} />}
      </div>

      {/* Zertifikat-Abzeichen (rechts oben) */}
      {diplom && (
        <div
          className={`${stile.abzeichenEcke} ${stile.abzeichenRechts}`}
          title={t('skill.zertifikatVorhanden')}
        >
          <ZertifikatIcon groesse={16} titel={t('skill.zertifikat')} />
        </div>
      )}

      {/* Technologie-Logo */}
      <div className={stile.skillLogoContainer}>
        <img src={logo} alt={title} width="70" height="70" className={stile.skillimg} loading="lazy" />
      </div>

      {/* Titel der Fähigkeit */}
      <h4 className={stile.skillTitel}>{title}</h4>

      {/* Sanfter interaktiver Hinweis */}
      <span className={stile.kartenHinweis}>{t('skill.details')}</span>
    </div>
  );
}

export default Skill;
